import React, { useState, useMemo, useEffect, useRef } from "react";
import { getPages } from '../../../apis/search';
import ReactPaginate from 'react-paginate';
import CustomContentItem from '../custom-content-item.jsx';
import { BasePageItem } from '../base-page-item.jsx';
import LoaderSection from '../loader-section.jsx';
import animatedScrollTo from 'animated-scroll-to';

const PAGESIZE = 12;

const SearchPages = props => {
    // state
    const [page, setPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [items, setItems] = useState([]);
    const [isLoading, setLoading] = useState(false);
   
    // handlers
    const handlePageClick = data => {
        setPage(data.selected + 1);
        animatedScrollTo(document.querySelector('.pages-top'));
    };

    const usePrevious = value => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    }
    const prevQ = usePrevious(props.q);
    // computed
    useEffect(() => {

        if (prevQ !== props.q)
            setPage(1);

        const params = {
            q: props.q,
            page: page,
            pageSize: PAGESIZE
        };

        setLoading(true);

        getPages(params)
            .then(data => {
                setItems(data.records);
                setTotalRecords(data.totalRecords);
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
            });

    }, [page, props.q]);

    const pages = useMemo(() => {
        return Math.ceil(totalRecords / PAGESIZE);
    }, [totalRecords]);

    const showPagination = useMemo(() => {
        return totalRecords > PAGESIZE;
    }, [totalRecords]);

    // template
    let section,
        pagination;

    if (showPagination) {
        pagination = <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={pages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            forcePage={page - 1}
        />;
    }

    if (isLoading) section = <LoaderSection show={true} />;

    const count = isLoading
        ? <></>
        : <p className="search-result-message"><span className="search-accent">{totalRecords}</span> results found for <span className="search-accent">'{props.q}'</span></p>;

    if (items.length > 0) {
        section =
            <div className="row section pages-top">
                {items.map((page, index) => (
                    <BasePageItem key={page.nodeGuid} colClass='col-lg-3' {...page} />
                ))}
            </div>;
    } else if (!isLoading) {
        section =
            <div className="row justify-content-center section">
                <p>No results found</p>
            </div>;
    }

    return <div>
        {count}
        {section}
        {pagination}
    </div>;
};

export default SearchPages;